import * as Yup from 'yup';
import { useRef, useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
// form
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
// @mui
import { Link, Stack, IconButton, InputAdornment, Typography } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import Iconify from '../../../components/iconify';
import { FormProvider, RHFTextField, RHFCheckbox } from '../../../components/hook-form';
// api
import axios from '../../../api/axios';
// context
import useAuthContext from '../../../context/AuthContext';

// ----------------------------------------------------------------------

export default function LoginForm() {
  const navigate = useNavigate();

  const userRef = useRef();
  const errRef = useRef();

  const [response, setResponse] = useState(null);
  const [error, setError] = useState(null);
  const [submit, setSubmit] = useState(false);

  const [showPassword, setShowPassword] = useState(false);

  const { login, errors } = useAuthContext();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required('Email est obligatoire').email('Email non valid'),
    password: Yup.string().required('Mot de pass est obligatoire'),
  });

  const defaultValues = {
    email: '',
    password: '',
    remember: true,
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = async (values) => {
    setSubmit(true);
    await login(values);
    setSubmit(false);
  };
  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(onSubmit)}>
      <Stack spacing={3}>
        <RHFTextField name="email" label="Email" multiline={false} />

        <RHFTextField
          multiline={false}
          name="password"
          label="Mot de passe"
          type={showPassword ? 'text' : 'password'}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>
      {errors && (
        <Typography variant="subtitle2" display="block" sx={{ color: '#FF0000', mt: 5 }} gutterBottom>
          {errors}
        </Typography>
      )}
      <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <RHFCheckbox name="remember" label="Rester connecté" />
        <Link variant="subtitle2" underline="hover">
          Mot de passe oublie?
        </Link>
      </Stack>

      <LoadingButton fullWidth size="large" type="submit" variant="contained" loading={submit}>
        Login
      </LoadingButton>
    </FormProvider>
  );
}
